import TC from "@/components/table/Table.module.css";

import { InfoTooltip, type WTooltipProps } from "@/components/WTooltip.tsx";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

export interface DetailsTableRowProps {
    title?: ReactNode;
    tooltip?: WTooltipProps["text"];
    children?: ReactNode;
    thWide?: boolean;
}

export function DetailsTableRow({ title, tooltip, children, thWide }: DetailsTableRowProps) {
    return title ? (
        <tr>
            <th className={cn(thWide && TC.Wide)}>
                <div className="flex">
                    {title}:{tooltip && <InfoTooltip className="ml-1" text={tooltip} />}
                </div>
            </th>
            <td>{children}</td>
        </tr>
    ) : (
        <tr>
            <td colSpan={2}>&nbsp;</td>
        </tr>
    );
}
